
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashion-finder-profile",
      function () {
        return require("private-next-pages/fashion-finder-profile.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashion-finder-profile"])
      });
    }
  